module.exports = __webpack_public_path__ + "img/IconPre-&Post-NatalCare.dda5b555.svg";